import AlertsviewTable from '@containers/main/alerts/alertsview-table'
import {Collapse} from 'antd'
import {useState} from 'react'
import {useDomain} from 'contexts/DomainContext'

const {Panel} = Collapse

const TargetAlerts = ({targetsview}) => {
  const [activeKey, setActiveKey] = useState(null) // Controls which panel is open
  const {terms} = useDomain()

  const handleChange = key => {
    // Toggle the panel: if the same key is clicked again, close it
    setActiveKey(activeKey === key ? null : key)
  }

  return (
    <Collapse activeKey={activeKey} onChange={handleChange}>
      <Panel header={terms.alerts || 'Alerts'} key="1" className="custom-panel">
        <AlertsviewTable
          query={{tg_id: targetsview.tg_id}}
          excludeItemInfo={true}
          showFilter={false}
          showLimit={false}
        />
      </Panel>
    </Collapse>
  )
}

export default TargetAlerts
